<template>
  <div>
    <h3 class="colorBlue">Actions Log ({{ category }})</h3>
    <el-table
      :data="items"
      style="width: 100%; font-size: 10px"
      border
      stripe
      sortable
      v-loading="loading"
      :default-sort="{ prop: 'created_at', order: 'descending' }"
    >
      <el-table-column prop="category" label="Category" sortable>
      </el-table-column>
      <el-table-column prop="action" label="Action" sortable> </el-table-column>
      <el-table-column prop="user_id" label="User" width="70" sortable>
      </el-table-column>
      <el-table-column prop="student_id" label="Child" width="80" sortable>
      </el-table-column>
      <el-table-column prop="school_id" label="School" width="80" sortable>
      </el-table-column>
      <el-table-column prop="created_at" label="Date" width="80" sortable>
      </el-table-column>
    </el-table>
  </div>
</template>
<style scoped>
h3 {
  font-size: 15px;
  z-index: 999;
}
i {
  font-size: 15px;
}
</style>
<script>
import ApiService from "@/services/ApiService";
export default {
  name: "actionsHistory",
  props: {
    path: String,
    school_id: Array,
    user_id: Number,
    student_id: Number,
  },
  data() {
    return {
      items: [],
      loading: true,
      pathToCategory: {
        new_term: "NEW_TERM_ACTION",
        move_children_up_a_year: "MOVE_CHILDREN_UP_YEAR_ACTION",
        remove_user_schools: "REMOVE_USER_SCHOOLS_ACTION",
        remove_non_user_data: "REMOVE_NON_USER_DATA_ACTION",
        send_admin_messages: "SEND_ADMIN_MESSAGES_ACTION",
        verify_notices: "VERIFY_NOTICES_ACTION",
        send_notifications: "SEND_NOTIFICATIONS_ACTION",
        send_service_emails: "SEND_SERVICE_EMAILS_ACTION",
        send_login_emails: "SEND_LOGIN_EMAILS_ACTION",
      },
      category: "",
      response: {
        status: 3,
        data: {
          total_users: 0,
          total_staff: 0,
          total_parents: 0,
          total_children: "0",
          total_cars: 0,
          total_active_time: 0,
          total_time: 0,
          total_distance: 0,
          total_journeys: 0,
          total_co2: 0,
          groupByDistance: [],
          groupsByTime: [],
          groupsByDistanceGroup: [],
          groupsByDistanceGroupCount: [],
          groupsByDistanceCountFormattedPercents: [],
          carsVsSustainable: [],
          journeysDistributionByDistance: [],
          carsData: {
            total_car_distance: "0",
            total_car_time: "0",
            total_car_journeys: 0,
            DIESEL: 0,
            PETROL: 0,
            ELECTRIC: 0,
            HUBRID: 0,
            total_pupils: "0",
            shared: "0",
          },
          habbitsBySchoolYear: [],
        },
      },
    };
  },
  watch: {
    school_id: function (obj) {
      this.getHistory();
      // this.kilometers = val;
      // this.meters = val * 1000;
    },
    // path: function() {}
  },
  methods: {
    getHistory() {
      this.loading = true;
      const params = {
        school_id: this.school_id,
        category: this.category,
        user_id: this.user_id ? this.user_id : null,
        student_id: this.student_id ? this.student_id : null,
      };
      ApiService.sadminApi.getActionsHistory(params).then((response) => {
        this.items = response.data;
        this.loading = false;
      });
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.category = this.pathToCategory[this.path];
      this.getHistory();
    });
  },
};
</script>
